export default __webpack_public_path__ + "static/media/poi-document.7c29d69c.png";